class ClientRegistrationContinueUsersController {
  static controller($rootScope, $scope, $state, PASSWORD_REGEX, PHONE_REGEX, ClientRegistrationService) {
    'ngInject';

    $scope.policyChecked = false;
    $scope.phoneRegex = PHONE_REGEX;
    $scope.registerClient = function(clientRegistrationStep2) {
      if(clientRegistrationStep2.$valid) {
        var  promise = ClientRegistrationService.register($state.params.registrationDataStep1, clientRegistrationStep2);
        
        promise.then(function(data) {
          $state.go('public.users.client.client-registration-confirm', {userName : $state.params.registrationDataStep1.email.$modelValue});
        });
        
      }
    };
  };
}

export default ClientRegistrationContinueUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-registration-continue.users.controller.js